<template>
  <layout-main-inner :title="`${info.exchangeGoodsId ? '编辑': '新增'}商品(${info.isVirtualProductBundle === 1 ? '组合': '单一'})`">
    <template slot="action">
      <el-button
        type="primary"
        @click="editGoods">保存</el-button>
    </template>
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">基本信息</template>
      <el-form
        ref="ruleForm"
        v-loading="loading"
        label-position="top"
        :model="info"
        :rules="rules"
        label-width="110px">
        <el-row
          :gutter="20"
          type="flex">
          <el-col :span="8">
            <el-form-item
              label="商品名称："
              prop="goodsName">
              <el-input v-model="info.goodsName"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            v-if="info.exchangeGoodsId"
            :span="8">
            <el-form-item
              key="10001"
              label="商品编码：">
              <!-- <el-input v-model="info.productNumber"></el-input> -->
              {{ info.productNumber }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="商品分组："
              prop="groupId">
              <product-group-select
                v-model="info.groupId"
                :option="{vendorId: userInfo.orgId}" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="商品描述："
              prop="goodsDesc">
              <el-input v-model="info.goodsDesc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="售价："
              prop="price">
              <span
                v-if="info.isVirtualProductBundle === 1"
                slot="label">
                <span>售价：</span>
                <el-tooltip
                  effect="dark"
                  content="组合商品的价格根据组合内各个商品的价格自动计算">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-input-number
                v-if="info.isVirtualProductBundle === 0"
                v-model="info.price"
                :min="0.01"
                :precision="2"></el-input-number>
              <span v-else>{{ info.price || '-' }}</span>元
            </el-form-item>
          </el-col>
          <el-col
            v-if="info.isVirtualProductBundle === 0"
            :span="8">
            <el-form-item
              label="商品库存："
              prop="storageCount">
              <el-input-number v-model="info.storageCount"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="已售数量："
              prop="exchangeCount">
              <el-input-number v-model="info.exchangeCount"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否上架：">
              <el-switch
                v-model="info.status"
                :active-value="1"
                :inactive-value="2">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="排序值："
              prop="sortNumber">
              <el-input-number
                v-model="info.sortNumber"
                :precision="0"
                :min="0"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="info.isVirtualProductBundle === 1"
          :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="选择商品"
              prop="virtualProductBundleBoms">
              <el-button
                style="margin-bottom: 10px"
                type="primary"
                @click="selectProduct">选择商品</el-button>
              <el-table
                style=""
                border
                :data="info.virtualProductBundleBoms">
                <el-table-column
                  label="商品名称"
                  prop="goodsName"
                  :resizable="false">
                </el-table-column>
                <el-table-column
                  label="商品编号"
                  width="90"
                  :resizable="false"
                  prop="productNumber">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  width="70"
                  label="商品分组"
                  prop="groupName">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  label="商品描述"
                  prop="goodsDesc"></el-table-column>
                <el-table-column
                  label="售价"
                  width="80"
                  :formatter="(row)=> '¥' + row.price"
                  prop="price">
                </el-table-column>
                <el-table-column
                  label="组合内单价"
                  :resizable="false"
                  prop="inBomPrice">
                  <template slot-scope="{$index}">
                    <el-form-item
                      label-width="0"
                      :prop="'virtualProductBundleBoms.' + $index + '.inBomPrice'"
                      :rules="[{required: true, message: '请输入组合售价', trigger: 'blur'}]">
                      <el-input-number
                        v-model="info.virtualProductBundleBoms[$index].inBomPrice"
                        style="width: 100%"
                        :precision="2"
                        :min="0"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="数量"
                  :resizable="false"
                  prop="inBomGoodsCount">
                  <template slot-scope="{$index}">
                    <el-form-item
                      label-width="0"
                      :prop="'virtualProductBundleBoms.' + $index + '.inBomGoodsCount'"
                      :rules="[{required: true, message: '请输入数量', trigger: 'blur'}]">
                      <el-input-number
                        v-model="info.virtualProductBundleBoms[$index].inBomGoodsCount"
                        style="width: 100%"
                        :precision="2"
                        :min="0"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="banner图片"
              prop="goodsSmallImage">
              <upload-with-crop
                v-model="info.goodsSmallImage"
                :cropper="true"
                :limit="5"
                :fixedNumber="[1,1]"
                :autoCropWidth="160"
                :autoCropHeight="160" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="图文详情："
              prop="goodsDetailsImage">
              <desc-images
                v-model="info.goodsDetailsImage"
                :edit="true"></desc-images>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <product-modal
        ref="product"
        :callback="formatProduct" />
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import UploadWithCrop from '@/components/wx/upload-with-crop.vue'
import DescImages from '@/components/public/desc-images.vue'
// E:\trunk\wxapp-vendor-v3\src\components\business\product-group-select.vue
import ProductGroupSelect from '@/components/wx/product-group-select.vue'
import NP from 'number-precision'
import { mapState } from 'vuex'
import ProductModal from './product-modal.vue'
export default {
  name: 'GoodsEdit',
  components: {
    DescImages,
    UploadWithCrop,
    ProductGroupSelect,
    ProductModal
  },
  data() {
    return {
      loading: false,
      info: {
        exchangeGoodsId: null,
        productNumber: '',
        isVirtualProductBundle: 1,
        goodsName: '',
        goodsDesc: '',
        price: null,
        storageCount: '',
        exchangeCount: 0,
        sortNumber: 1,
        status: 1,
        goodsPayType: 1,
        goodsDetailsImage: [],
        goodsSmallImage: [],
        virtualProductBundleBoms: []
      },
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'change' },
          { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'change' }
        ],
        goodsDesc: [
          { required: true, message: '请输入商品描述', trigger: 'change' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'change' }
        ],
        productNumber: [
          { required: true, pattern: /^[0-9\.]{3,12}$/, message: '请输入商品编码,只能输入数字和".",长度3-12', trigger: 'change' }
        ],
        groupId: [
          { required: true, message: '请选择商品分组', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入商品现金', trigger: 'change' }
        ],
        storageCount: [
          { required: true, message: '请输入商品库存', trigger: 'change' }
        ],
        virtualProductBundleBoms: [
          { required: true, message: '请选择组合商品', trigger: 'change' }
        ],
        exchangeCount: [
          { required: true, message: '请输入已售数量', trigger: 'change' }
        ],
        sortNumber: [
          { required: true, message: '请输入排序值', trigger: 'change' }
        ],
        goodsDetailsImage: [
          { required: true, message: '请录入商品详情图片', trigger: 'change' }
        ],
        goodsSmallImage: [
          { required: true, message: '请输入商品图片(小图)', trigger: 'change' }
        ]

      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  watch: {
    'info.virtualProductBundleBoms': {
      handler(val) {
        if (this.info.isVirtualProductBundle === 0) {
          return
        }
        // console.log(val)
        this.info.price = val.map(u => NP.times(u.inBomPrice, u.inBomGoodsCount)).reduce((total, num) => NP.plus(total, num), 0)
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route.query.exchangeGoodsId) {
      this.getgoods()
    }
  },
  methods: {
    selectProduct() {
      this.$refs.product.fetch(this.info.virtualProductBundleBoms)
    },
    formatProduct(row) {
      const list = this.info.virtualProductBundleBoms
      const result = row.map(i => {
        const item = list.find(s => s.goodsId === i.goodsId)
        if (item > -1) {
          return item
        } else {
          return {
            ...i,
            inBomPrice: 0,
            inBomGoodsCount: 1
          }
        }
      })
      this.$set(this.info, 'virtualProductBundleBoms', result)
    },
    getgoods() {
      this.loading = true
      this.$store.dispatch('goods/getgoods', {
        payload: this.$route.query,
        success: res => {
          this.loading = false
          this.info = {
            ...res.data,
            goodsSmallImage: res.data.goodsSmallImage ? res.data.goodsSmallImage.split(',').map(item => ({
              url: item,
              name: item
            })) : [],
            goodsDetailsImage: res.data.goodsDetailsImage ? res.data.goodsDetailsImage.split(',').map(item => ({
              url: item,
              name: item,
              mediaType: /(\.mp4|\.webm|\.avi)$/g.test(item) ? 2 : 1
            })) : []
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    editGoods() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.$route.query.exchangeGoodsId ? 'updategoods' : 'addgoods'
          this.$store.dispatch(`goods/${dispatch}`, {
            payload: {
              vendorId: this.$route.query.vendorId,
              // goodsName: this.info.goodsName,
              // groupId: this.info.groupId,
              // goodsDesc: this.info.goodsDesc,
              // goodsPayType: this.info.goodsPayType,
              // price: this.info.price,
              // storageCount: this.info.storageCount,
              // exchangeCount: this.info.exchangeCount,
              // status: this.info.status,
              ...this.info,
              virtualProductBundleBoms: this.info.isVirtualProductBundle === 0 ? null : this.info.virtualProductBundleBoms.map(i => {
                return {
                  goodsId: i.goodsId,
                  inBomPrice: i.inBomPrice,
                  inBomGoodsCount: i.inBomGoodsCount
                }
              }),
              goodsDetailsImage: this.info.goodsDetailsImage.map(i => i.url).join(','),
              goodsSmallImage: this.info.goodsSmallImage.map(item => item.url).join(',')
              // exchangeGoodsId: this.$route.query.exchangeGoodsId || null
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
